import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../../components/card/AttivaCard";
import useHandleErrors from "../../../../hooks/useHandleErrors";
import PageHeader from "../../../../layout/shared/page-header";
import { menuRoutes } from "../../../../router/menu";
import { KoReasonService } from "../../../../services/ko-reason/koReasonService";
import KoReasonForm from "../KoReasonForm";

const pageHeader = {
    title: "Crear Motivo de KO",
    breadcrumb: [
        { name: 'Administración' },
        { name: 'Gestión de estados' },
        { name: 'Motivos de KO', href: menuRoutes.states.path + menuRoutes.states.koReasons },
        { name: "Crear" },
    ],
};

const KoReasonCreate: FC = () => {

    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new KoReasonService();

    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = (await service.createKoReason(values)).getResponseData();

            if (response.success) {
                navigate(-1);
                toast.success("Motivo de KO creado correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al crear el motivo de KO");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos Principales" className="mb-4">
                <KoReasonForm submit={handleSubmit} isLoading={loading} />
            </AttivaCard>
        </>
    );
}

export default KoReasonCreate;
